import React, { useMemo, Suspense, lazy } from 'react';
import { v4 as uuid } from 'uuid';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import FormField from '../../../atoms/Form/Field/FormField';
import FieldError from '../../Error/FieldError';

const RichText = lazy(() => import('../../RichText/RichText'));
import { getConfidenceFieldStyle } from '../../../../helpers/form';

const RichTextFieldRender = ({
  input,
  label,
  placeholder,
  id,
  readonly,
  hasModulesCustom,
  confidence,
  meta: { error, touched },
  isFocusOnInit,
  validation,
  height,
}) => {
  const style = useMemo(() => {
    if (touched) return null;
    return getConfidenceFieldStyle(confidence);
  }, [confidence, touched]);

  return (
    <>
      <Suspense>
        <RichText
          {...input}
          isFocusOnInit={isFocusOnInit}
          error={!!(touched && error)}
          label={label}
          id={id}
          block
          height={height}
          readonly={readonly}
          placeholder={placeholder}
          hasModulesCustom={hasModulesCustom}
          style={style}
          validation={validation}
        />
      </Suspense>
      {touched && error && <FieldError error={error} />}
    </>
  );
};

RichTextFieldRender.propTypes = {
  height: PropTypes.string,
  validation: PropTypes.object,
  isFocusOnInit: PropTypes.bool,
  input: PropTypes.object,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  meta: PropTypes.shape({
    error: PropTypes.any,
    touched: PropTypes.bool,
  }),
  id: PropTypes.string,
  readonly: PropTypes.bool,
  hasModulesCustom: PropTypes.bool,
  confidence: PropTypes.number,
};

const RichTextField = ({
  name,
  label,
  required,
  information,
  verticalAlign = true,
  fieldHoC: FieldHoC = Field,
  hasModulesCustom = false,
  answersChoices = null,
  validation,
  confidence,
  ...props
}) => {
  const id = useMemo(() => uuid(), [name]);
  return (
    <FormField
      label={label}
      name={name}
      htmlFor={id}
      required={required}
      information={information}
      verticalAlign={verticalAlign}
      answersChoices={answersChoices}
      confidence={confidence}
    >
      <FieldHoC
        name={name}
        component={RichTextFieldRender}
        id={id}
        validation={validation}
        confidence={confidence}
        {...props}
        hasModulesCustom={hasModulesCustom}
      />
    </FormField>
  );
};

RichTextField.propTypes = {
  height: PropTypes.string,
  validation: PropTypes.object,
  name: PropTypes.string,
  label: PropTypes.string,
  required: PropTypes.bool,
  information: PropTypes.string,
  fieldHoC: PropTypes.func,
  verticalAlign: PropTypes.bool,
  hasModulesCustom: PropTypes.bool,
  answersChoices: PropTypes.array,
  confidence: PropTypes.number,
};

export default RichTextField;
